import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import UsageCurrent from '../components/UsageCurrent'
import globals from '../globals'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import UsageGraphsMobile from '../components/UsageGraphsMobile'
import { NETWORK_TELSTRA, SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_WIRELESS } from '../constants'
import UsageGraphsBroadband from '../components/UsageGraphsBroadband'
import TabNavItem from '../elements/TabNavItem'

class UsageSummary extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            // Mobile
            data: {},
            calls: {},
            international: {},
            usageCurrent: [],
            // Broadband
            totals: [],
            peak: [],
            offPeak: [],
            dateLabels: [],
            // Daily
            usageDaily: [],
            dateLabelsDaily: []
        }

        this.myRefs = []
    }

    componentDidMount () {
        DataSource.getData(`/api/getUsage/${this.getType()}/${this.props.serviceId}`, result => {
            this.setState({
                usageCurrent: [this.buildDateField(), ...result.usageCurrent, ...this.buildRechargeFields()],
                data: result.usageHistorical.data ? result.usageHistorical.data : {},
                calls: result.usageHistorical.calls ? result.usageHistorical.calls : {},
                international: result.usageHistorical.international ? result.usageHistorical.international : {},
                totals: result.usageHistorical.totals ? result.usageHistorical.totals : [],
                peak: result.usageHistorical.peak ? result.usageHistorical.peak : [],
                offPeak: result.usageHistorical.offPeak ? result.usageHistorical.offPeak : [],
                dateLabels: result.usageHistorical.dateLabels ? result.usageHistorical.dateLabels : [],
                usageDaily: result.usageDaily && result.usageDaily.totals ? result.usageDaily.totals : [],
                dateLabelsDaily: result.usageDaily && result.usageDaily.dateLabels ? result.usageDaily.dateLabels : [],
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleClick (event, ref) {
        globals.handleTabClick(event, this.btnContainer, this.myRefs, ref)
    }

    getType () {
        if (this.props.type === SERVICE_MOBILE || this.props.type === SERVICE_MOBILE_BROADBAND || this.props.type === SERVICE_WIRELESS) {
            return 'mobile'
        }

        return 'broadband'
    }

    buildDateField () {
        return {
            type: 'date',
            daysLeftInCurrentBillingCycleText: this.props.serviceDetails.daysLeftInCurrentBillingCycleText,
            nextBillingCycleStart: this.props.serviceDetails.nextBillingCycleStart,
            billingCycleProgressPercentage: this.props.serviceDetails.billingCycleProgressPercentage
        }
    }

    buildRechargeFields () {
	    const data = []
	    if (this.props.type === SERVICE_MOBILE && this.props.serviceDetails.networkProvider === NETWORK_TELSTRA) {
            data.push({
                type: 'text',
                title: 'Auto-recharge end of cycle',
                summaryText: `Next recharge ${this.props.serviceDetails.nextBillingCycleStart}`,
                usageDescription: 'Mandatory on'
            })

            if (this.props.serviceDetails.autoRechargeZeroData) {
                data.push({
                    type: 'text',
                    title: 'Auto-recharge on zero data',
                    summaryText: 'Enabled',
                    usageDescription: 'Optional'
                })
            }
        }

        return data
    }

    render () {
	    const DailyUsageUrl = () => {
	        const link = this.getType() === 'mobile'
                ? <TabNavItem to={this.props.getUrl('detailed-usage')} className='color-grey sub-bold'>detailed usage</TabNavItem>
                : <TabNavItem to={this.props.getUrl('daily-usage')} className='color-grey sub-bold'>daily usage detail</TabNavItem>

	        return <p className='text-center mt-4 mb-0'>You can get more comprehensive usage data in the {link} tab.</p>
        }

        return (
            <div className='my-usage module'>
                <Heading title='Usage summary' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12 w-100 usage-wrapper' ref={el => this.btnContainer = el}>
                            <a href='#' className='inner-tab gtm-service-usage-tab-click active' onClick={event => this.handleClick(event, this.myRefs[0])}>{this.props.isTelstra ? 'This cycle' : 'This month'}</a>
                            {this.state.usageDaily.length > 0 ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[7])}>Daily usage</a> : ''}
                            {Object.keys(this.state.data).length > 0 ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[1])}>Data usage (last 6 {this.props.isTelstra ? 'cycles' : 'mths'})</a> : ''}
                            {Object.keys(this.state.calls).length && this.props.type === SERVICE_MOBILE > 0 ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[2])}>Calls (last 6 {this.props.isTelstra ? 'cycles' : 'mths'})</a> : ''}
                            {Object.keys(this.state.international).length > 0 && this.props.type === SERVICE_MOBILE ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[3])}>International (last 6 {this.props.isTelstra ? 'cycles' : 'mths'})</a> : ''}
                            {this.state.totals.length > 0 ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[4])}>Data usage (6 {this.props.isTelstra ? 'cycles' : 'mths'})</a> : ''}
                            {this.state.peak.length > 0 ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[5])}>Peak usage (6 mths)</a> : ''}
                            {this.state.offPeak.length > 0 ? <a href='#' className='inner-tab gtm-service-usage-tab-click' onClick={event => this.handleClick(event, this.myRefs[6])}>Off-peak usage (6 mths)</a> : ''}

                            <div ref={el => this.myRefs[0] = el}>
                                <UsageCurrent usage={this.state.usageCurrent} isUnlimitedUsage={this.props.serviceDetails.isUnlimitedUsage} />
                            </div>

                            {Object.keys(this.state.data).length > 0
                                ? <div ref={el => this.myRefs[1] = el} style={{ display: 'none' }}>
                                    <UsageGraphsMobile usageHistorical={this.state.data} />
                                  </div>
                                : ''}
                            {Object.keys(this.state.calls).length > 0
                                ? <div ref={el => this.myRefs[2] = el} style={{ display: 'none' }}>
                                    <UsageGraphsMobile usageHistorical={this.state.calls} />
                                  </div>
                                : ''}
                            {Object.keys(this.state.international).length > 0
                                ? <div ref={el => this.myRefs[3] = el} style={{ display: 'none' }}>
                                    <UsageGraphsMobile usageHistorical={this.state.international} />
                                  </div>
                                : ''}
                            {this.state.usageDaily.length > 0
                                ? <div ref={el => this.myRefs[7] = el} style={{ display: 'none' }}>
                                    <UsageGraphsBroadband usageHistorical={this.state.usageDaily} labels={this.state.dateLabelsDaily}>
                                        {DailyUsageUrl()}
                                    </UsageGraphsBroadband>
                                  </div>
                                : ''}
                            {this.state.totals.length > 0
                                ? <div ref={el => this.myRefs[4] = el} style={{ display: 'none' }}>
                                    <UsageGraphsBroadband usageHistorical={this.state.totals} labels={this.state.dateLabels} />
                                  </div>
                                : ''}
                            {this.state.peak.length > 0
                                ? <div ref={el => this.myRefs[5] = el} style={{ display: 'none' }}>
                                    <UsageGraphsBroadband usageHistorical={this.state.peak} labels={this.state.dateLabels}>
                                        <p className='text-center mt-4 mb-0'>Your peak period is {this.props.serviceDetails.peakPeriod}.</p>
                                    </UsageGraphsBroadband>
                                  </div>
                                : ''}
                            {this.state.offPeak.length > 0
                                ? <div ref={el => this.myRefs[6] = el} style={{ display: 'none' }}>
                                    <UsageGraphsBroadband usageHistorical={this.state.offPeak} labels={this.state.dateLabels}>
                                        <p className='text-center mt-4 mb-0'>Your off-peak period is {this.props.serviceDetails.offpeakPeriod}.</p>
                                    </UsageGraphsBroadband>
                                  </div>
                                : ''}
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

UsageSummary.propTypes = {
    type: PropTypes.string.isRequired,
    serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    serviceDetails: PropTypes.object.isRequired,
    getUrl: PropTypes.func,
    isTelstra: PropTypes.bool
}

export default UsageSummary



// WEBPACK FOOTER //
// ./resources/js/modules/UsageSummary.js